import React, { useEffect } from "react";
import { motion } from "framer-motion";
import PageHeader from "../components/sections/PageHeader";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import MagentButton from "../components/elements/MagnetButton";
import FeaturedContentFull from "../components/sections/FeaturedContentFull";

const ServicesPage = () => {
  const cardVariantsScaled = {
    offscreen: {
      y: -20,
      opacity: 0,
    },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.6,
        duration: 1.4,
        delay: 0.2,
      },
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.5 }}>
      <Header showLogo={true} />

      <div className="relative">
        <PageHeader title={"Our Services"} imageName={"services-shipping"} titleSmaller={false} />
        <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-[hsla(0,0%,0%,0.25)] bg-fixed"></div>
      </div>

      <div className="container my-24 mx-auto md:px-6">
        <section className="mb-32 text-center mx-auto max-w-[980px] md:text-left">
          <div className="mb-12 grid items-center gap-x-6 md:grid-cols-2 xl:gap-x-12">
            <div className="mb-6 md:mb-0">
              <div
                className="relative mb-6 overflow-hidden rounded-lg bg-cover bg-no-repeat shadow-lg dark:shadow-black/20"
                data-te-ripple-init
                data-te-ripple-color="light"
              >
                <img src="images/services-1.jpg" className="w-full" alt="Louvre" />

                <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100 bg-[hsla(0,0%,98.4%,.15)]"></div>
              </div>
            </div>

            <div>
              <h3 className="mb-3 text-4xl font-bold text-primary-900">Procurement</h3>
              <p className="text-primary-100 font-light text-lg">
                With access to over 100 trusted suppliers and rigorous quality checks, we offer a streamlined procurement process. Imagine the peace
                of mind, knowing you’re getting the best ingredients, hassle-free.
              </p>

              <br />

              <p className="text-primary-100 font-light text-lg">
                Logistics? We’ve got you covered there too. We handle the details, ensuring ingredients reach your doorstep.
              </p>

              <br />

              <p className="text-primary-100 font-light text-lg">
                Leave the complexity to us. Focus on creating exceptional products while we handle the rest. Your success is our mission.
              </p>
            </div>
          </div>

          <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }} variants={cardVariantsScaled}>
            <div className="mb-12 grid items-center gap-x-6 md:grid-cols-2 xl:gap-x-12">
              <div className="mb-6 md:order-2 md:mb-0">
                <div
                  className="relative mb-6 overflow-hidden rounded-lg bg-cover bg-no-repeat shadow-lg dark:shadow-black/20"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                >
                  <img src="images/services-2.jpg" className="w-full" alt="Louvre" />

                  <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100 bg-[hsla(0,0%,98.4%,.15)]"></div>
                </div>
              </div>

              <div className="md:order-1">
                <h3 className="mb-3 text-4xl font-bold text-primary-900">Quality Control</h3>
                <p className="text-primary-100 font-light text-lg">
                  We meticulously vet suppliers and conduct rigorous quality checks. Rest assured, your ingredients are of the highest quality.
                </p>

                <br />

                <p className="text-primary-100 font-light text-lg">
                  We even offer lab testing services to verify purity and safety. We leave no room for compromise.
                </p>

                <br />

                <p className="text-primary-100 font-light text-lg">With us, you can focus on creating, knowing that quality is our top priority.</p>
              </div>
            </div>
          </motion.div>

          <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }} variants={cardVariantsScaled}>
            <div className="mb-12 grid items-center gap-x-6 md:grid-cols-2 xl:gap-x-12">
              <div className="mb-6 md:mb-0">
                <div
                  className="relative mb-6 overflow-hidden rounded-lg bg-cover bg-no-repeat shadow-lg dark:shadow-black/20"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                >
                  <img src="images/services-3.jpg" className="w-full" alt="Louvre" />

                  <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100 bg-[hsla(0,0%,98.4%,.15)]"></div>
                </div>
              </div>

              <div>
                <h3 className="mb-3 text-4xl font-bold text-primary-900">Custom Blending</h3>
                <p className="text-primary-100 font-light text-lg">
                  Our team specializes in crafting custom blends to fit your exact needs. No more settling for generic solutions.
                </p>

                <br />

                <p className="text-primary-100 font-light text-lg">
                  With us, you have a partner who understands your vision. We work with you to create blends that align with your product goals.
                </p>

                <br />

                <p className="text-primary-100 font-light text-lg">
                  Your unique formulations, simplified. Discover how we make custom blending effortless.
                </p>
              </div>
            </div>
          </motion.div>
        </section>
      </div>

      <div
        className="flex justify-center items-center bg-top bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080"><g transform=" rotate(183 960 540) translate(-88.00438535234775 -49.5024667606956) scale(1.091671234742029) "><rect width="1920" height="1080" fill="rgb(173, 173, 173)"></rect><g transform="translate(0, 0)"><path fill="rgb(189, 189, 189)" fill-opacity="1" d="M0,284.442L106.667,278.994C213.333,273.545,426.667,262.647,640,266.803C853.333,270.959,1066.667,290.169,1280,249.629C1493.333,209.09,1706.667,108.801,1813.333,58.657L1920,8.513L1920,1080L1813.333,1080C1706.667,1080,1493.333,1080,1280,1080C1066.667,1080,853.333,1080,640,1080C426.667,1080,213.333,1080,106.667,1080L0,1080Z"></path></g><g transform="translate(0, 360)"><path fill="rgb(206, 206, 206)" fill-opacity="1" d="M0,244.355L106.667,243.531C213.333,242.708,426.667,241.061,640,202.665C853.333,164.269,1066.667,89.123,1280,80.392C1493.333,71.661,1706.667,129.345,1813.333,158.187L1920,187.028L1920,720L1813.333,720C1706.667,720,1493.333,720,1280,720C1066.667,720,853.333,720,640,720C426.667,720,213.333,720,106.667,720L0,720Z"></path></g><g transform="translate(0, 720)"><path fill="rgb(222, 222, 222)" fill-opacity="1" d="M0,247.154L106.667,265.258C213.333,283.362,426.667,319.571,640,301.881C853.333,284.191,1066.667,212.603,1280,176.038C1493.333,139.473,1706.667,137.932,1813.333,137.162L1920,136.391L1920,360L1813.333,360C1706.667,360,1493.333,360,1280,360C1066.667,360,853.333,360,640,360C426.667,360,213.333,360,106.667,360L0,360Z"></path></g></g></svg>')`,
        }}
      >
        <div className="container my-12 mx-auto max-w-[980px] md:px-6 px-6">
          <section className="mb-32 max-[600px]:mb-0">
            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }} variants={cardVariantsScaled}>
              <div className="flex justify-center mb-24">
                <div className="max-w-[700px] text-center">
                  <h2 className="mb-6 text-4xl font-bold text-primary-100">Why MONNUTRA</h2>
                  <p className="text-primary-100 font-light text-lg">
                    Choosing Monnutra means more than just services; it’s a commitment to excellence. With a seasoned team dedicated to quality,
                    unmatched industry experience, a trail of satisfied clients, and the added assurance of fast and global shipping, we stand as your
                    trusted partner in elevating your business to new heights.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }} variants={cardVariantsScaled}>
              <div className="grid gap-x-6 md:grid-cols-2 lg:grid-cols-4 xl:gap-x-12">
                <div className="mb-12">
                  <div className="flex">
                    <div className="shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="mr-3 h-5 w-5 text-success"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="ml-2 grow">
                      <p className="mb-1 font-bold text-primary-100">Support 24/7</p>
                      <p className="text-primary-100 font-light text-sm">
                        Our support is available 24/7, ensuring that your concerns are addressed promptly and efficiently.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-12">
                  <div className="flex">
                    <div className="shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="mr-3 h-5 w-5 text-success"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="ml-2 grow">
                      <p className="mb-1 font-bold text-primary-100">Quick Shipping</p>
                      <p className="text-primary-100 font-light text-sm">
                        Experience the convenience of rapid shipping, ensuring that your orders reach you in no time.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-12">
                  <div className="flex">
                    <div className="shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="mr-3 h-5 w-5 text-success"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="ml-2 grow">
                      <p className="mb-1 font-bold text-primary-100">5 Star Rating</p>
                      <p className="text-primary-100 font-light text-sm">
                        Our commitment to excellence is reflected in our consistent 5-star ratings from satisfied customers.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-12">
                  <div className="flex">
                    <div className="shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="mr-3 h-5 w-5 text-success"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="ml-2 grow">
                      <p className="mb-1 font-bold text-primary-100">Dedicated Support</p>
                      <p className="text-primary-100 font-light text-sm">
                        Our dedicated support team is here to assist you every step of the way, providing unparalleled service.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </section>
        </div>
      </div>

      {/*                            */}
      {/* 🟩 Featured Content Full   */}
      {/*                            */}
      <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }} variants={cardVariantsScaled}>
        <FeaturedContentFull />
      </motion.div>

      {/*                            */}
      {/* 🟩 Footer                  */}
      {/*                            */}
      <motion.div
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.8 }}
        variants={cardVariantsScaled}
        className="flex justify-center items-center bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080"><g transform=" rotate(194 960 540) translate(-384.36393238172263 -216.20471196471897) scale(1.400379096230961) "><rect width="1920" height="1080" fill="rgb(252, 102, 1)"></rect><g transform="translate(0, 0)"><path fill="rgb(253, 114, 21)" fill-opacity="1" d="M0,264.707L64,262.556C128,260.405,256,256.103,384,255.436C512,254.769,640,257.737,768,258.071C896,258.405,1024,256.104,1152,227.387C1280,198.67,1408,143.537,1536,138.881C1664,134.225,1792,180.045,1856,202.956L1920,225.866L1920,1080L1856,1080C1792,1080,1664,1080,1536,1080C1408,1080,1280,1080,1152,1080C1024,1080,896,1080,768,1080C640,1080,512,1080,384,1080C256,1080,128,1080,64,1080L0,1080Z"></path></g><g transform="translate(0, 270)"><path fill="rgb(254, 126, 40)" fill-opacity="1" d="M0,4.145L64,36.907C128,69.669,256,135.193,384,151.514C512,167.835,640,134.953,768,104.517C896,74.081,1024,46.091,1152,60.539C1280,74.987,1408,131.872,1536,142.129C1664,152.386,1792,116.015,1856,97.83L1920,79.644L1920,810L1856,810C1792,810,1664,810,1536,810C1408,810,1280,810,1152,810C1024,810,896,810,768,810C640,810,512,810,384,810C256,810,128,810,64,810L0,810Z"></path></g><g transform="translate(0, 540)"><path fill="rgb(254, 138, 60)" fill-opacity="1" d="M0,79.529L64,105.937C128,132.344,256,185.158,384,213.523C512,241.888,640,245.804,768,213.506C896,181.208,1024,112.697,1152,84.467C1280,56.237,1408,68.289,1536,94.704C1664,121.12,1792,161.899,1856,182.289L1920,202.679L1920,540L1856,540C1792,540,1664,540,1536,540C1408,540,1280,540,1152,540C1024,540,896,540,768,540C640,540,512,540,384,540C256,540,128,540,64,540L0,540Z"></path></g><g transform="translate(0, 810)"><path fill="rgb(255, 150, 79)" fill-opacity="1" d="M0,253.429L64,233.844C128,214.259,256,175.089,384,135.235C512,95.38,640,54.842,768,32.523C896,10.205,1024,6.106,1152,30.809C1280,55.513,1408,109.018,1536,125.837C1664,142.655,1792,122.785,1856,112.85L1920,102.916L1920,270L1856,270C1792,270,1664,270,1536,270C1408,270,1280,270,1152,270C1024,270,896,270,768,270C640,270,512,270,384,270C256,270,128,270,64,270L0,270Z"></path></g></g></svg>')`,
        }}
      >
        <Footer />
      </motion.div>
    </motion.div>
  );
};

export default ServicesPage;
